// คำทักทายตามช่วงเวลา จากการตั้งค่าของระบบ (greetingConfig = settings.greeting)
// ได้ประโยคเช่น "สวัสดีตอนเที่ยงค่ะ คุณสมชาย อย่าลืมทานข้าวนะ"
export function slotFor(date) {
  const hour = date.getHours();
  if (date.getDay() === 5 && hour >= 12 && hour < 21) return 'friday';
  if (hour >= 5 && hour < 11) return 'morning';
  if (hour >= 11 && hour < 13) return 'noon';
  if (hour >= 13 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'night';
}

export function greetingFor(date, greetingConfig, name) {
  const slot = (greetingConfig.slots && greetingConfig.slots[slotFor(date)]) || { hello: 'สวัสดี', extra: '' };
  return buildGreeting(slot, greetingConfig.particle, name);
}

export function buildGreeting(slot, particle, name) {
  const parts = [`${slot.hello}${particle || ''}`];
  if (name) parts.push(`คุณ${name}`);
  if (slot.extra) parts.push(slot.extra);
  return { text: parts.join(' ') };
}

// ข้อความต่อท้าย: จำนวนการประชุมของตัวเองวันนี้
export function todaySummary(myMeetingsToday) {
  if (!myMeetingsToday) return 'วันนี้คุณไม่มีประชุม';
  return `วันนี้คุณมีประชุม ${myMeetingsToday} รายการ`;
}
